(function (w, d) {
  'use strict';
  if (w.FocusPodClarity) return;
  var node = d.getElementById('fp-clarity-config');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  var loaded = false, halted = false, active = false, seen = new Set(), records = [];
  var map = {
    view_pod_details: 'fp_product_view', configurator_start: 'fp_configurator_start',
    configuration_complete: 'fp_configuration_complete', add_to_quote: 'fp_add_to_quote',
    quote_start: 'fp_quote_start', quote_submit_attempt: 'fp_quote_submit_attempt',
    generate_lead: 'fp_enquiry_confirmed', phone_click: 'fp_phone_click', email_click: 'fp_email_click',
    request_spec_sheet: 'fp_spec_requested', download_spec_sheet: 'fp_spec_download'
  };
  function internal() {
    var p = new URLSearchParams(w.location.search), saved = false;
    try { saved = localStorage.getItem('focuspod_internal_browser_v1') === '1' || sessionStorage.getItem('focuspod_internal_session_v1') === '1'; } catch (_) {}
    return String(config.theme_role).toLowerCase() !== 'main' || config.design_mode === true || saved ||
      w.FocusPodInternalTraffic === true || w.FP_INTERNAL_TRAFFIC === true || p.has('preview_theme_id') ||
      p.has('fp_qa_id') || p.get('fp_internal') === '1' || p.get('view') === 'fp-au-responsive-check' ||
      (p.get('utm_source') === 'internal_qa' && p.get('utm_medium') === 'test');
  }
  function consent(method) {
    try { return w.Shopify.customerPrivacy[method]() === true; } catch (_) { return false; }
  }
  function permitted() {
    return !internal() && /^[A-Z]{2}$/.test(config.market) && consent('analyticsProcessingAllowed');
  }
  function command() { if (typeof w.clarity === 'function') w.clarity.apply(w, arguments); }
  function event(name, key) {
    if (!/^fp_[a-z_]+$/.test(name)) return;
    if (key && seen.has(key)) return;
    if (key) seen.add(key);
    records.push({ event: name, delivery: active && permitted() ? 'clarity' : 'local-only' });
    if (records.length > 60) records.shift();
    if (active && permitted()) command('event', name);
  }
  function page() {
    var path = w.location.pathname.replace(/\/$/, '') || '/';
    event('fp_page_view', 'page');
    if (path === '/') event('fp_home_view', 'home');
    if (path === '/pages/office-pod-price-australia') event('fp_prices_view', 'prices');
    if (path === '/pages/configurator') event('fp_configurator_view', 'configurator');
    if (/\/pages\/(contact-us|request-for-quote|us-contact|fp-contact)$/.test(path)) event('fp_enquiry_view', 'enquiry');
  }
  function reconcile() {
    if (!permitted()) {
      if (loaded && !halted) {
        command('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
        command('stop'); halted = true;
      }
      active = false;
      return;
    }
    if (halted) return;
    if (!loaded) {
      loaded = true;
      w.clarity = w.clarity || function () { (w.clarity.q = w.clarity.q || []).push(arguments); };
      command('consentv2', { analytics_Storage: 'granted', ad_Storage: consent('marketingAllowed') && consent('saleOfDataAllowed') && !w.navigator.globalPrivacyControl ? 'granted' : 'denied' });
      command('set', 'site_domain', w.location.hostname.toLowerCase().replace(/^www\./, ''));
      command('set', 'site_market', config.market);
      command('set', 'traffic_type', 'external');
      command('set', 'measurement_version', 'fp_clarity_v1');
      command('set', 'page_type', config.page_type);
      active = true;
      page();
      var script = d.createElement('script');
      script.async = true; script.src = 'https://www.clarity.ms/tag/' + config.project;
      script.id = 'fp-clarity-collector';
      script.onerror = function () { active = false; };
      d.head.appendChild(script);
    } else {
      command('consentv2', { analytics_Storage: 'granted', ad_Storage: consent('marketingAllowed') && consent('saleOfDataAllowed') && !w.navigator.globalPrivacyControl ? 'granted' : 'denied' });
    }
  }
  function observed(e) {
    var detail = e.detail || {}, name = map[detail.event];
    if (!name) return;
    var id = detail.parameters && detail.parameters.event_id;
    event(name, id ? name + ':' + id : null);
  }
  d.addEventListener('focuspod:measurement_observed', observed);
  d.addEventListener('focuspod:clarity_observed', observed);
  d.addEventListener('focuspod:quote_email_status', function (e) {
    var detail = e.detail || {};
    if (['attempt', 'queued', 'submitted_to_provider', 'delivered', 'unconfirmed'].indexOf(detail.status) < 0) return;
    event('fp_quote_email_' + detail.status, detail.id ? 'email:' + detail.status + ':' + detail.id : null);
  });
  d.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || e.button > 0 || e.defaultPrevented) return;
    var url;
    try { url = new URL(link.href, w.location.href); } catch (_) { return; }
    if (url.origin !== w.location.origin) return;
    if (/\/pages\/(request-for-quote|contact-us|us-contact|fp-contact)$/.test(url.pathname)) event('fp_enquiry_cta_click');
  }, true);
  d.addEventListener('invalid', function (e) {
    if (e.target.closest && e.target.closest('#FocusPodUSContact,#FocusPodMarketContact,#fp-autoquote-dialog')) event('fp_enquiry_validation_error', 'validation');
  }, true);
  w.addEventListener('fp:viewer-error', function () {
    event('fp_configurator_viewer_error');
    if (config.market !== 'AU' || d.getElementById('fp-viewer-recovery')) return;
    var root = d.querySelector('.us-configurator');
    if (!root) return;
    var notice = d.createElement('p'), link = d.createElement('a');
    notice.id = 'fp-viewer-recovery'; notice.setAttribute('role', 'alert');
    notice.style.cssText = 'padding:12px 16px;margin:0;border-bottom:1px solid currentColor;font:inherit;position:relative;z-index:21;background:var(--background,#fff)';
    notice.appendChild(d.createTextNode(config.viewer_error + ' '));
    link.href = '/pages/contact-us'; link.textContent = config.contact_label;
    notice.appendChild(link); root.prepend(notice);
  });
  w.addEventListener('fp:viewer-ready', function () {
    var notice = d.getElementById('fp-viewer-recovery');
    if (notice) notice.remove();
  });
  d.addEventListener('visitorConsentCollected', reconcile);
  w.addEventListener('pageshow', reconcile);
  w.FocusPodClarity = Object.freeze({ diagnostics: function () { return { internal: internal(), active: active, stopped: halted, events: records.slice() }; } });
  reconcile();
})(window, document);
